module.exports = __webpack_public_path__ + "images/8baaddfc5609b9c7422e12fd963f52c4.jpg";